module.exports = __webpack_public_path__ + "static/media/footer-icon-closed.5f4f6ddd.svg";